import { useContext } from 'react';

import { PortalSessionContext } from './PortalSessionContext';
import type { PortalSessionValue } from './portalSessionTypes';

export function usePortalSession(): PortalSessionValue {
  const context = useContext(PortalSessionContext);

  if (!context) {
    throw new Error(
      'usePortalSession must be used within PortalSessionProvider.',
    );
  }

  return context;
}
